var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "13px",
    width: "10.59px",
    viewBox: "0 0 10.59 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1c3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "userIconFull"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "iconHead",
    className: "cls-1",
    cx: 5.3,
    cy: 3.26,
    r: 3.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconBody",
    className: "cls-1",
    d: "M8.84,13H1.74C.68,13-.13,12.25,0,11.41L.76,9A1.66,1.66,0,0,1,2.49,7.77H8.1A1.66,1.66,0,0,1,9.83,9l.75,2.45C10.72,12.25,9.91,13,8.84,13Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.e6ae2acb1ea075fd8b1d9b714c2b9da4.svg";
export { ForwardRef as ReactComponent };